// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

const customTheme = {
  dark: false,
  colors: {
    primary: '#0dd36b',     // 메인 색상
    gray50: '#f1f1f1',   // 서브 색상
    gray100: '#d3d3d3',
    gray200: '#bdbdbd',
    gray300: '#9f9f9f',
    gray400: '#8d8d8d',
    gray500: '#707070',
    gray600: '#666666',
    gray700: '#505050',
    gray800: '#3e3e3e',
    gray900: '#2f2f2f'
  },
};

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify(
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
)

export const vuetify = createVuetify({
  theme: {
    defaultTheme: 'customTheme',
    themes: {
      customTheme,
    },
  },
});